/**
 * "Läs mer"-länken i kategorins intro-text scrollar mjukt till den långa
 * beskrivningen längst ned (#lang-beskrivning).
 *
 * Avståndet till den klistrade headern kommer från scroll-margin-top på
 * målet (se collection-intro-faq.css), som scrollIntoView respekterar.
 *
 * Lyssnaren är delegerad till document, så den överlever att produktlistan
 * byggs om vid ajax-filtrering och paginering. Saknas målet på sidan gör
 * länken ingenting utöver webbläsarens vanliga ankarbeteende.
 */
(function scrollToCollectionDescription() {
  document.addEventListener('click', (evt) => {
    const link = evt.target.closest('[data-scroll-to-description]');
    if (!link) return;

    const target = document.getElementById('lang-beskrivning');
    if (!target) return;

    evt.preventDefault();

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // tabindex="-1" på målet gör att tangentbords- och skärmläsarfokus
    // följer med scrollen.
    target.focus({ preventScroll: true });

    window.history.replaceState(null, '', '#lang-beskrivning');
  });
}());
